var _ = require('underscore');
var BrecTableView = require('./../widget/brec-table/BrecTableView');
var EstimatesListWidget = require('./EstimatesListWidget');
var estimatesBrecListTemplate = require('./estimatesBrecListTemplate.hbs');
var financialFeatureService = require('./../financial/financialFeatureService');
var applicationUtils = require('./../applicationUtils');
var withSidebarClassNameModifier = '';
if (applicationUtils.currentApplication === applicationUtils.APPLICATIONS.ADMIN_TOOL) {
  withSidebarClassNameModifier = ' brec-tab__content--side';
}

/**
 * Brec List for account estimates
 *
 * @class EstimatesBrecListView
 */
module.exports = BrecTableView.extend({
  tagName: 'section',
  className: 'brec-tab__content' + withSidebarClassNameModifier,
  id: 'tab-content',
  template: estimatesBrecListTemplate,

  prepareFields: {
    currentApplication: applicationUtils.currentApplication,
    showPaymentButton: '_checkPaymentAllowed'
  },

  widgetOptions: _.defaults({
    table: {
      active: true
    },
    pagination: {
      active: true
    }
  }, BrecTableView.prototype.widgetOptions),

  /**
   * @method initialize
   * @override
   */
  initialize: function(options) {
    this.tableState.set('patientVecnaId', options.patientVecnaId);
    this.widgetOptions.table.tableView = new EstimatesListWidget({ tableState: this.tableState });
    BrecTableView.prototype.initialize.apply(this, arguments);
  },

  /**
   * Check payment allowed
   * @method _checkPaymentAllowed
   */
  _checkPaymentAllowed: function() {
    var patientPaymentAllowed = financialFeatureService.patientPaymentAllowed(this.patientVecnaId);
    var adminPaymentAllowed = financialFeatureService.adminPaymentAllowed();
    return patientPaymentAllowed || adminPaymentAllowed;
  }
});
